import React from "react";
import CampaignsManager from "@/components/campaigns/CampaignsManager";

export default function CampaignsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-outfit font-semibold text-3xl md:text-4xl text-slate-900 tracking-tight">Campaigns</h1>
        <p className="text-sm text-slate-600 mt-1">
          Map each campaign to a brand, FTD/RD type, and team. When you upload a mixed-campaign ops file, the app auto-routes rows by this map.
        </p>
      </div>
      <CampaignsManager />
    </div>
  );
}
